var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-to-fakturabank",attrs:{"href":_vm.fakturabankUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }